<template>
    <md-dialog :md-active="show" @md-closed="$emit('close')">
      <md-card class="modal-card">
        <md-card-media>
          <img src="@/assets/images/Imagenes_icono_kia_exp.png" alt="Icono Kia" class="modal-image">
        </md-card-media>
  
        <md-card-media>
          <img src="@/assets/images/Imagenes_green_camera.png" alt="Cámara verde" class="modal-image">
        </md-card-media>
  
        <md-card-content class="text-center">
          <p>¡Tu cita con  nuestro asesor ha sido programada!

            Recibirás un mensaje de confirmación a tu correo electrónico. 
            
            ¡No olvides conectarte al link de la videollamada el día de la cita!
            ¡Estamos aquí para ayudarte!
            </p>
        </md-card-content>

        <md-card-actions>
            <md-button @click="$emit('close')" class="close-button">Cerrar</md-button>
        </md-card-actions>


      </md-card>
    </md-dialog>
  </template>
  
  <script>
  export default {
    props: {
      show: {
        type: Boolean,
        required: true
      },
    },
   

  };
  </script>
  
  <style scoped>
  .modal-card {
    width: 450px; 
    height: 470px;
    margin: auto;
    background-color: white !important;
    color: white;
    border-radius: 8px; 
    padding: 20px; 
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    text-align: center;
  }
  
  .text-center {
    color: black; 
    font-size: 16px; 
    margin-top: 20px; 
  }
  
  .modal-image {
    max-width: 145px; 
    height: auto;
    margin: 10px 0;
  }
  
  .md-dialog {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ::v-deep(.md-dialog-container) {
    background-color: white !important; 
  }

  ::v-deep(.md-overlay) {
    background-color: rgba(0, 0, 0, 0.3) !important; 
  }

  .close-button {
    background-color: #05141f !important; 
    color: white; 
    padding: 10px 20px; 
    border: none;
    border-radius: 5px; 
    cursor: pointer;
    font-size: 16px; 
    margin-top: 20px; 
  }
  
  .close-button:hover {
    background-color: #45a049; 
  }

  </style>